/**
 * Product Upsell Handlers
 * Global functions for handling product upsell add to cart and variant selection
 */

// Handle variant selection change
window.handleProductUpsellVariantChange = function (selectElement, formId, skipImage) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const productJsonEl = document.getElementById("ProductJson-" + formId);
  if (!productJsonEl) {
    console.error("Product JSON not found for form:", formId);
    return;
  }

  try {
    const product = JSON.parse(productJsonEl.textContent);
    const selects = form.querySelectorAll('select[name^="options["]');
    const selectedOptions = Array.from(selects).map((s) => s.value);

    // Find matching variant
    const variant = product.variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

    if (variant) {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      // Update all price displays (button, toggle, and standalone)
      if (variant.price != null) {
        const currency = document.querySelector('meta[name="currency"]')?.content || "USD";
        const formattedPrice = formatMoney(variant.price, currency);
        const container = form.closest('[class*="upsell-product-container-"]');
        if (container) {
          container.querySelectorAll('.upsell-price, [class*="upsell-toggle-price-"], [class*="upsell-product-price-"]').forEach(function (el) {
            el.textContent = formattedPrice;
          });
        }
      }


      // Update product image to match selected variant
      var img = skipImage ? null : form.querySelector("img");
      if (img) {
        var imgData = variant && variant.featured_image ? variant.featured_image : null;
        if (!imgData && product.featured_image) {
          // Fallback to product featured image
          var fi = product.featured_image;
          imgData = { src: typeof fi === "string" ? fi : fi.src, alt: "" };
        }
        if (imgData && imgData.src) {
          var newSrc = imgData.src.replace(/^\/\//, "https://").split("?")[0] + "?width=150";
          if (newSrc !== img.src) {
            var preload = new Image();
            preload.onload = function () {
              img.src = newSrc;
              if (imgData.alt) img.alt = imgData.alt;
            };
            preload.src = newSrc;
          }
        }
      }
    }

    // Disable unavailable variant option combinations
    selects.forEach(function (currentSelect, idx) {
      Array.from(currentSelect.options).forEach(function (opt) {
        var test = selectedOptions.slice();
        test[idx] = opt.value;
        opt.disabled = !product.variants.some(function (v) {
          return test.every(function (val, i) {
            return v.options[i] === val;
          });
        });
      });
    });
  } catch (error) {
    console.error("Error handling variant change:", error);
  }
};

// Handle add to cart
window.handleProductUpsellAdd = async function (buttonElement, formId) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  const cartAction = form.dataset.cartAction || "drawer";

  // Disable button and show loading state
  const originalHTML = buttonElement.innerHTML;
  buttonElement.disabled = true;
  buttonElement.classList.add("is-loading");
  buttonElement.innerHTML = '<span class="button-spinner"></span>';

  try {
    if (cartAction === "redirect") {
      const response = await fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });
      if (!response.ok) throw new Error("Failed to add to cart");
      const text = await response.text();
      const data = JSON.parse(text);
      if (data.status) throw new Error(data.description || "Failed to add to cart");
      window.location = window.routes?.cart_url || "/cart";
      return;
    }

    // Drawer: same request as shop-cart-button-handler (FormData + sections) so we get section HTML and open drawer
    const formData = new FormData(form);
    formData.append("sections", "cart-drawer,cart-icon-bubble");
    formData.append("sections_url", window.location.pathname);

    const response = await fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: formData,
    });

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error("Cart add returned non-JSON (likely HTML). Response ok:", response.ok, "Status:", response.status);
      throw new Error("Unable to add to cart. Please try again.");
    }
    if (data.status) {
      console.error("Error adding to cart:", data.description);
      throw new Error(data.description || "Error adding product to cart");
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(data);
    }

    if (typeof upsellCarousel === "function") {
      upsellCarousel();
    }

    // Show success state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-success");
    buttonElement.innerHTML = "✓ Added!";

    // Update cart count bubble
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-success");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  } catch (error) {
    console.error("Error adding to cart:", error);

    // Show error state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-error");
    buttonElement.innerHTML = "✗ Error";

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-error");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  }
};

// Handle toggle switch add/remove from cart
window.handleProductUpsellToggle = async function (toggleElement, formId, uniqueId) {
  // Prevent double-calling
  if (toggleElement.dataset.processing === "true") {
    return;
  }
  toggleElement.dataset.processing = "true";

  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  // Use uniqueId to find the toggle switch more reliably
  const toggleSwitch = document.querySelector(".upsell-toggle-switch-" + uniqueId) || toggleElement.parentElement;
  const isAdding = toggleElement.checked;

  const cartAddUrl = window.routes?.cart_add_url || "/cart/add";
  const cartChangeUrl = window.routes?.cart_change_url || "/cart/change";

  // Show loading state
  if (toggleSwitch) {
    toggleSwitch.classList.add("is-loading");
  }

  try {
    if (isAdding) {
      // Add to cart
      const response = await fetch(cartAddUrl + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }
    } else {
      // Remove from cart - first get cart to find the line item
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      // Find the item in cart
      const cartItem = cart.items.find((item) => item.variant_id == variantId);

      if (cartItem) {
        // Calculate new quantity (decrease by 1)
        const newQuantity = cartItem.quantity - 1;

        // Update cart
        const response = await fetch(cartChangeUrl + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId.toString(),
            quantity: newQuantity,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to remove from cart");
        }
      }
    }

    // Success - remove loading state
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";

    // Update cart count bubble
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    if (typeof window.refreshCartDrawer === "function") {
      await window.refreshCartDrawer();
    }
  } catch (error) {
    console.error("Error updating cart:", error);

    // Revert toggle state on error
    toggleElement.checked = !toggleElement.checked;
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";
  }
};

// Event delegation for toggle switches - more reliable than inline handlers
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("upsell-toggle-input")) {
      const formId = e.target.dataset.formId;
      const uniqueId = e.target.dataset.uniqueId;
      if (formId && uniqueId) {
        handleProductUpsellToggle(e.target, formId, uniqueId);
      }
    }
  });
});
// Helper function to format money
function formatMoney(cents, currency = "USD") {
  const amount = cents / 100;

  // Try to use Shopify's money format if available
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format || "{{amount}}");
  }

  // Fallback formatting
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amount);
}

/* ==========================================================
   אפסל – סנכרון דו-כיווני מול העגלה
   ----------------------------------------------------------
   הסוויץ׳ בעמוד הבית והעגלה מציגים תמיד את אותו מצב:

   • טעינת העמוד – אם המנוי בעגלה, הסוויץ׳ מסומן.
   • סימון הסוויץ׳ – רק מסמן בחירה, לא נוגע בעגלה. ההוספה
     קורית בלחיצה על כפתור ההוספה הראשי.
   • ביטול הסימון – מוריד את המנוי מהעגלה מיד.
   • שינוי בעגלה מכל מקום אחר (הוספה מהמגירה, מחיקה,
     שינוי כמות) – הסוויץ׳ מתעדכן בהתאם.

   שלוש נקודות טכניות:

   1. מוצר המנוי מוגדר "ניתן לרכישה רק כמנוי", ולכן חובה
      לשלוח selling_plan בכל הוספה. בלעדיו מתקבלת שגיאה 422.
      תוכנית המנוי נלקחת מה-JSON של המוצר שבעמוד (ProductJson-<form id>),
      כך שאם התוכנית מתחלפת באפליקציית המנויים (Stripe) – אין צורך לעדכן קוד.

   2. ל-input יש גם onchange inline וגם מאזין מואצל, כך
      שהפונקציה נקראת פעמיים על כל שינוי. dataset.processing
      משמש כמנעול כדי שההסרה תרוץ פעם אחת בלבד.

   3. כפתור ההוספה הראשי עובר דרך product-form ולא דרך
      skipToCheckout, ולכן מתחברים אליו בהאזנה ללחיצה בשלב
      ה-capture.
   ========================================================== */
(function () {
  /* תוכנית המנוי (selling plan) של וריאנט, מתוך ה-JSON של המוצר בטופס:
     ההקצאה של הוריאנט, ואם אין – התוכנית הראשונה של המוצר. */
  function sellingPlanFor(formId, variantId) {
    var el = formId ? document.getElementById('ProductJson-' + formId) : null;
    if (!el) return null;
    try {
      var product = JSON.parse(el.textContent);
      var variant = (product.variants || []).filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      var alloc = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];
      if (alloc && alloc.selling_plan_id) return alloc.selling_plan_id;
      var group = (product.selling_plan_groups || [])[0];
      var plan = group && (group.selling_plans || [])[0];
      return plan ? plan.id : null;
    } catch (e) {
      return null;
    }
  }

  function variantOf(input) {
    var form = document.getElementById(input.dataset.formId);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput ? idInput.value : null;
  }

  function toggles() {
    return Array.prototype.slice.call(document.querySelectorAll('.upsell-toggle-input'));
  }

  /* ---- סנכרון מצב הסוויץ׳ לפי תוכן העגלה ---- */
  function applyCart(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[String(item.variant_id)] = item; });

    toggles().forEach(function (input) {
      var variant = variantOf(input);
      if (!variant) return;
      var shouldBeChecked = !!inCart[String(variant)];
      if (input.checked !== shouldBeChecked) { input.checked = shouldBeChecked; }
    });
  }

  function syncFromCart() {
    return fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(applyCart)
      .catch(function () {});
  }

  /* ---- הסוויץ׳: סימון = בחירה בלבד, ביטול = הסרה מהעגלה ---- */
  window.handleProductUpsellToggle = function (input) {
    if (!input || input.dataset.processing === 'true') return;
    input.dataset.processing = 'true';
    var unlock = function () { input.dataset.processing = 'false'; };

    if (input.checked) { setTimeout(unlock, 0); return; }

    var variant = variantOf(input);
    if (!variant) { setTimeout(unlock, 0); return; }

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (item) {
          return String(item.variant_id) === String(variant);
        })[0];
        if (!line) return null;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        })
          .then(function (response) { return response.json(); })
          .then(function () {
            if (typeof window.refreshCartDrawer === 'function') { return window.refreshCartDrawer(); }
          });
      })
      .then(unlock, unlock);
  };

  /* ---- כפתור ההוספה הראשי: מוסיף גם את האפסל המסומן ----
     הסינון מונע הוספה כפולה אם המנוי כבר בעגלה. */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.shop-add-to-cart-button')
      : null;

    if (!button || button.dataset.upsellPassthrough === '1') return;

    var checked = toggles().filter(function (input) { return input.checked; });
    if (!checked.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) { inCart[String(item.variant_id)] = true; });

        var items = checked
          .map(function (input) { return { input: input, variant: variantOf(input) }; })
          .filter(function (x) { return x.variant && !inCart[String(x.variant)]; })
          .map(function (x) {
            var item = { id: x.variant, quantity: 1 };
            var plan = sellingPlanFor(x.input.dataset.formId, x.variant);
            if (plan) { item.selling_plan = plan; }
            return item;
          });

        if (!items.length) return null;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          if (!response.ok) {
            return response.text().then(function (t) { console.error('upsell-sync: add failed', response.status, t); });
          }
        });
      })
      .catch(function (error) { console.error('upsell-sync:', error); })
      .then(function () {
        button.dataset.upsellPassthrough = '1';
        button.click();
        setTimeout(function () { delete button.dataset.upsellPassthrough; }, 2000);
      });
  }, true);

  /* ---- כפתור האפסל שבמגירת העגלה ---- */
  window.handleProductUpsellAdd = function (buttonElement, formId) {
    var form = document.getElementById(formId);
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var originalHTML = buttonElement.innerHTML;
    buttonElement.disabled = true;

    var formData = new FormData(form);
    var plan = sellingPlanFor(formId, idInput.value);
    if (plan) { formData.append('selling_plan', plan); }
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'cart error'); }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(data); }
        return syncFromCart();
      })
      .catch(function (error) {
        console.error('upsell-add:', error);
        buttonElement.innerHTML = '✗';
        setTimeout(function () {
          buttonElement.innerHTML = originalHTML;
          buttonElement.disabled = false;
        }, 2000);
      });
  };

  /* ---- מתי מסנכרנים ---- */
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, syncFromCart);
  }
  window.addEventListener('focus', syncFromCart);
  window.addEventListener('pageshow', syncFromCart);
  syncFromCart();
})();
